import { escapeHtml } from "./dom";

// Renders a placeholder-first image: shows a teal gradient box with a label
// until the real file exists at /img/<file>, at which point it swaps in seamlessly.
export function img(file: string, label: string, aspectRatio: string): string {
  const src = `/img/${file}`;
  const safeLabel = escapeHtml(label);
  return `<div class="ph-img" data-label="${safeLabel}" style="aspect-ratio:${aspectRatio}">
    <img src="${src}" alt="${safeLabel}" loading="lazy"
      onload="this.closest('.ph-img').classList.add('has-image')"
      onerror="this.remove()" />
  </div>`;
}
